/**
 * In-house error tracking contract shared by the API and the web client.
 * Kept in sync with apps/api/src/modules/error-logs/error-logs.schemas.ts.
 * Platform-admin only (`/admin/error-logs`) - except `ClientErrorReport`,
 * which the web app posts for its own browser-side crashes.
 */
export const ERROR_LOG_SOURCES = ['API', 'WORKER', 'BACKGROUND_JOB', 'PROCESS', 'WEB'];
export const ERROR_LOG_STATUSES = ['OPEN', 'RESOLVED', 'ARCHIVED'];
//# sourceMappingURL=error-logs.js.map